import React, { useEffect } from 'react'

import { Box, Heading, Loading, Text, Stack, Center } from '@myxplor/stardust'

import useSchema from '~/utils/useSchema'
import SurveyRenderer from '~/components/SurveyRenderer'
import MaxWidthLayout from '~/layouts/MaxWidthLayout'
import ErrorMessage from '~/components/ErrorMessage'

const Renderer = props => {
  const { serviceId, childId, guid } = props
  const isReEnrolment = !!guid
  const enrolmentToken = new URLSearchParams(window.location.search).get('token')
  const [schema, getSchema] = useSchema()

  useEffect(() => {
    getSchema(serviceId, childId, guid, isReEnrolment, enrolmentToken)
  }, [])

  return (
    <MaxWidthLayout>
      <Box padding="large">
        <Stack align="center" space="medium" width={1}>
          <Text fontSize="18px">{/* Childcare centre service name goes here */}</Text>
          <Heading level={4} fontSize="36px">
            {isReEnrolment ? 'Re Enrolment Form' : 'Enrolment Form'}
          </Heading>
          <Heading
            level={2}
            weight="semiBold"
            color="higherEmphasis"
            style={{ lineHeight: 1, fontWeight: 'bold' }}
          >
            Let&apos;s Get Started.
          </Heading>
          <Center>
            <Heading level={5}>
              A few questions about your child will help us make your first day a breeze.
            </Heading>
            <Text prefab="subtitleAlt" color="higherEmphasis" fontSize="14px">
              This enrolment form is in accordance with the Education and Care Services National Regulations.
            </Text>
          </Center>
        </Stack>

        <Stack align="center" space="small">
          {schema.error && <ErrorMessage width={1 / 2}>{schema.error}</ErrorMessage>}
          {!schema.error && schema.loading && <Loading />}
          {!schema.error && schema.data && (
            <SurveyRenderer
              schema={schema.data.schema}
              initialData={schema.data.formData}
              progressBar={true}
              childId={childId ? childId : schema.data.childId}
              serviceId={serviceId ? serviceId : schema.data.serviceId}
              isReEnrolment={isReEnrolment}
              guid={guid}
              {...props}
            />
          )}
        </Stack>
      </Box>
    </MaxWidthLayout>
  )
}

export default Renderer
